module.exports = __webpack_public_path__ + "images/liinilaevad/android-icon-512x512.png";